import React, { useEffect, useRef, useState } from "react";
import { FaPlay, FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";

function Momentssection() {
  const sectionRef = useRef(null);
  const [data, setData] = useState({
    video: {},
    content: { button: {} }
  });

  /* ===== SCROLL ANIMATION ===== */
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && sectionRef.current) {
          sectionRef.current.classList.add("in-view");
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  /* ===== JSON + XML ===== */
  useEffect(() => {
    // ✅ JSON → UI
    fetch("/api/moments.json")
      .then(res => res.json())
      .then(json => {
        console.log("MOMENTS JSON:", json);
        setData(json);
      })
      .catch(err => console.error("MOMENTS JSON ERROR:", err));

    // ✅ XML → exam / proof
    fetch("/api/moments.xml")
      .then(res => res.text())
      .then(() => console.log("Moments XML loaded"));
  }, []);

  return (
    <>
      <section className="moments-section" ref={sectionRef}>
        <div className="moments-container">

          {/* ===== LEFT VIDEO ===== */}
          <div className="video-wrapper reveal-left">
            <Link to={data.video.link || "#"} className="video-overlay">
              <div className="play-button">
                <FaPlay />
              </div>
            </Link>
            <img src={data.video.thumbnail} alt="Moments Video" />
          </div>

          {/* ===== RIGHT CONTENT ===== */}
          <div className="moments-text reveal-right">
            <h2>
              <img src={data.content.icon} alt="" width="35" />
              {data.content.title}
              <span className="line"></span>
            </h2>

            <h3>{data.content.subtitle}</h3>

            <p>{data.content.description}</p>

            <Link to={data.content.button.link} className="btn-watch">
              {data.content.button.text} <FaArrowRight />
            </Link>
          </div>

        </div>
      </section>
      {/* ===== MOMENTS SECTION CSS ===== */}
      <style>{`
/* ================= MOMENTS SECTION ================= */

.moments-section {
  padding: 80px 20px;
  background: #fff;
  overflow-x: hidden;
}

.moments-container {
  max-width: 1300px;
  margin: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  align-items: center;
}

/* VIDEO */
.video-wrapper {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 15px 40px rgba(0,0,0,0.15);
  opacity: 0;
  transition: all 0.9s ease;
}

.video-wrapper img {
  width: 100%;
  display: block;
}

/* OVERLAY */
.video-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.4s ease;
}

.video-wrapper:hover .video-overlay {
  background: rgba(0,0,0,0.55);
}

/* PLAY BUTTON */
.play-button {
  width: 80px;
  height: 80px;
  background: var(--primary-color, #a6ce39);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  font-size: 28px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.play-button:hover {
  transform: scale(1.1);
}

/* TEXT */
.moments-text {
  opacity: 0;
  transition: all 0.9s ease;
}

.moments-text h2 {
  font-size: 28px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
}

.moments-text h2 .line {
  display: inline-block;
  height: 2px;
  width: 60px;
  background: var(--primary-color, #a6ce39);
}

.moments-text h3 {
  font-size: 22px;
  margin-bottom: 15px;
  font-weight: 600;
}

.moments-text p {
  font-size: 15px;
  line-height: 1.7;
  margin-bottom: 25px;
  color: #444;
}

/* BUTTON */
.btn-watch {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 26px;
  background: var(--primary-color, #a6ce39);
  color: #000;
  font-weight: 700;
  border-radius: 6px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.btn-watch:hover {
  background: #000;
  color: #fff;
  transform: translateY(-3px);
}

/* ===== SCROLL ANIMATION (ONLY THIS SECTION) ===== */
.reveal-left {
  transform: translateX(-80px);
}

.reveal-right {
  transform: translateX(80px);
}

.moments-section.in-view .reveal-left,
.moments-section.in-view .reveal-right {
  opacity: 1;
  transform: translateX(0);
}

/* RESPONSIVE */
@media (max-width: 992px) {
  .moments-container {
    grid-template-columns: 1fr;
  }
}
      `}</style>
    </>
  );
}

export default Momentssection;
